module.exports = __webpack_public_path__ + "img/prtr_footer_white.png";